// Admin org-context switcher directory.
//
// USE_REAL_API-gated like the other api/<x>.ts modules: real engine hits the
// live Ring-3 /admin/org-directory surface (real buy/supply orgs + member
// counts); dev (MSW) intercepts the same path. Replaces the former frontend
// mock org directory used by OrgSearchModal.

import { apiUrl } from '../lib/api'
import type { DirectoryOrg } from '../mocks/data/organizations'
import type { OrgViewSide } from '../lib/orgViewState'

type ApiOrg = {
  org_id: string
  org_name: string
  org_type: string
  side: string
  member_count: number
}

export async function fetchOrgDirectory(side: OrgViewSide): Promise<DirectoryOrg[]> {
  const res = await fetch(apiUrl(`/admin/org-directory?side=${side}`))
  if (!res.ok) throw new Error(`fetch org directory failed: ${res.status}`)
  const data = (await res.json()) as { items: ApiOrg[] }
  return data.items.map((o) => ({
    orgId: o.org_id,
    orgName: o.org_name,
    orgType: o.org_type as DirectoryOrg['orgType'],
    side,
    memberCount: o.member_count,
  }))
}
